<template>
  <v-card class="folie">
    <v-container>
      <v-card-title class="display-3">{{ this.title }}</v-card-title>
      <v-card-text class="title" align="start">
        <slot></slot>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "Standardfolie",
  props: {
    title: String,
    imgsrc: String
  }
};
</script>

<style scoped>
.folie {
  min-height: 80vh;
}
</style>
